/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Invitation_Delivery_Not_ConfiguredInputs */

const fr_api_invitation_delivery_not_configured = /** @type {(inputs: Api_Invitation_Delivery_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L’envoi des invitations n’est pas configuré. Contactez un administrateur.`)
};

const en_api_invitation_delivery_not_configured = /** @type {(inputs: Api_Invitation_Delivery_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invitation delivery is not configured. Contact an administrator.`)
};

/**
* | output |
* | --- |
* | "Invitation delivery is not configured. Contact an administrator." |
*
* @param {Api_Invitation_Delivery_Not_ConfiguredInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const api_invitation_delivery_not_configured = /** @type {((inputs?: Api_Invitation_Delivery_Not_ConfiguredInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Invitation_Delivery_Not_ConfiguredInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_invitation_delivery_not_configured(inputs)
	return fr_api_invitation_delivery_not_configured(inputs)
});